import { FC, forwardRef, useImperativeHandle, useRef } from 'react';
import { isNotEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';

/**
 * 详情容器
 * @description 主要提供给详情页使用。提供 top 顶部、default 内容主体、bottom 底部 三个插槽。其中 default 超出内容超出时内部滚动。
 * 当 Data/V2Container 出现不正常的更新内容（使内容插槽组件刷新），可以尝试使用该组件。
 * @category Data
 * @return {*}
 * @demo
import Container from 'src/common/components/Container/index';

<Container style={{ height: '200px', }} title='标题'/>
<Container
  style={{ height: 'calc(100vh - 57px - 48px - 8px)' }}
  top={<span>头部插槽</span>}
  bottom={<span>底部插槽</span>}
>
  <div style={{ height: '2000px' }}>占位内容，高度超出，内部可滚动。</div>
</Container>
 */
const Component:FC<{
  /** 标题 */
  title?: string,
  /** 顶部插槽 */
  top?: any,
  /** 底部插槽 */
  bottom?: any,
  className?: any,
  style?: any,
  children?: any,
} & {ref?: any}> = forwardRef(({ title = '', top, bottom, className, style, children }, ref) => {

  useImperativeHandle(ref, () => ({
    scrollTop
  }));

  const main: any = useRef();

  // main 滚动至顶部
  const scrollTop = (top = 0) => {
    main.current.scrollTop = +top || 0;
  };

  return (<div className={cs(styles.container, className)} style={style}>
    {/* 顶部 */}
    {top || isNotEmpty(title) && <div className={styles.containerTop}>{top || title}</div>}
    {/* 内容主体 */}
    <div ref={main} className={styles.containerMain}>{children}</div>
    {/* 底部 */}
    {bottom && <div className={styles.containerBottom}>{bottom}</div>}
  </div>);
});

export default Component;
